import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { customer_register, messageClear } from "../store/reducers/authReducer";
import { migrateGuestCart } from "../store/reducers/guestcartReducer";
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";
import { Helmet } from "react-helmet";

const Register = () => {
  const originUrl = window.location.origin;
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);

  const [state, setState] = useState({
    name: "",
    email: "",
    password: "",
    accept_policies: false,
    personaldata: false,
  });
  const dispatch = useDispatch();

  const inputHandle = e => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const handleCheckboxChange = e => {
    const { name, checked } = e.target;
    setState(prev => ({
      ...prev,
      [name]: checked,
    }));
  };

  const register = e => {
    e.preventDefault();
    dispatch(customer_register(state));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
      // Migración del carrito solo si hay guestId y userInfo está disponible
      const guestId = localStorage.getItem("guestId");
      if (guestId && userInfo?.id) {
        console.log("Iniciando migración de carrito...");
        dispatch(
          migrateGuestCart({
            userId: userInfo.id,
            guestId,
          })
        )
          .unwrap()
          .catch(error => {
            console.error("Error en migración:", error);
            toast.error(error?.errorMessage || "Error al migrar el carrito");
          });
      }
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }

    if (userInfo) {
      const timer = setTimeout(() => {
        const redirectPath = sessionStorage.getItem("redirectPath") || "/";
        const shippingData = sessionStorage.getItem("shippingData");

        if (shippingData) {
          navigate("/envio", { state: JSON.parse(shippingData) });
          sessionStorage.removeItem("shippingData");
        } else {
          navigate(redirectPath);
        }
        sessionStorage.removeItem("redirectPath");
      }, 500); // Pequeño delay para asegurar procesamiento

      return () => clearTimeout(timer);

      // navigate("/");
    }
  }, [successMessage, errorMessage, userInfo, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <Helmet>
        <title>Crea tu cuenta | Tekos.pe</title>
        <meta name="description" content="Compra zapatillas Adidas al mejor precio en Tekos. Envíos a todo Perú." />
        <meta name="keywords" content="zapatillas, Adidas, ofertas, calzado deportivo" />
      </Helmet>
      <div className="bg-slate-200 min-h-screen py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center">
          {/* Contenedor principal - cambia a columna en móvil */}
          <div className="w-full max-w-6xl bg-white rounded-md shadow-md overflow-hidden">
            <div className="grid grid-cols-2 sm:grid-cols-1 ">
              {/* Formulario (primero en móvil) */}
              <div className="p-6 md:p-8">
                <h2 className="text-center text-xl text-slate-600 font-bold mb-6">Crea tu cuenta</h2>
                <form onSubmit={register} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="name">Nombre</label>
                    <input
                      onChange={inputHandle}
                      value={state.name}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-pink-custom rounded-md"
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Nombre"
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="email">Correo electrónico</label>
                    <input
                      onChange={inputHandle}
                      value={state.email}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-pink-custom rounded-md"
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Correo electrónico"
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="password">Contraseña</label>
                    <input
                      onChange={inputHandle}
                      value={state.password}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-pink-custom rounded-md"
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Contraseña"
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="accept_policies" className="flex items-center gap-2 cursor-pointer">
                      <input
                        className="form-check-input checkbox"
                        type="checkbox"
                        name="accept_policies"
                        id="accept_policies"
                        checked={state.accept_policies}
                        onChange={handleCheckboxChange}
                        required
                      />
                      <span className="text-label">
                        <span style={{ color: "red" }}>*</span> He leído y acepto los{" "}
                        <Link to="/terminos-y-condiciones" title="Términos y condiciones" className="text-pink-custom hover:underline">
                          Términos y condiciones
                        </Link>{" "}
                        y{" "}
                        <Link to="/politica-de-seguridad-y-privacidad" title="Seguridad y privacidad" className="text-pink-custom hover:underline">
                          Política de Privacidad
                        </Link>
                      </span>
                    </label>
                  </div>
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="personaldata" className="flex items-center gap-2 cursor-pointer">
                      <input className="form-check-input checkbox" type="checkbox" name="personaldata" id="personaldata" checked={state.personaldata} onChange={handleCheckboxChange} />
                      <span className="text-label">Autorizo el tratamiento de mis datos para fines de prospección y promoción comercial</span>
                    </label>
                  </div>
                  <button className="px-8 w-full py-2 bg-[#ae1d22] hover:bg-[#e03550] text-white rounded-md transition-colors">CREA TU CUENTA</button>
                </form>
                {/* Enlace a login */}
                <div className="text-center text-slate-600 mt-4">
                  <p>¿Tienes una cuenta?</p>
                  <Link to="/login">
                    <div className="mt-2 px-8 w-full py-2 bg-white border-2 border-pink-custom hover:bg-pink-50 text-gray-800 rounded-md transition-colors">INICIAR SESIÓN</div>
                  </Link>
                </div>
              </div>
              {/* Imagen (oculta en móvil) */}
              <div className="sm:hidden bg-gray-100">
                <img src={`${originUrl}/images/login.jpg`} alt="Registro" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
